import { openShelf } from './controls';

// Arriving somewhere from a link or a dot that sets a filter (filters review F11, Kristi Nov 2):
// the fold it leads to opens if folded, then the page scrolls there, so the result is in view.
// Other folds stay as they were. Reference's Jump to uses the same steps.

/** What's pinned at the top right now: the top bar, and the page's bar unless it has slid away. */
export function pinnedBottom(): number {
  return [...document.querySelectorAll<HTMLElement>('.hdr, .ptop, .shelves-top, .queue-top')].reduce((m, x) => Math.max(m, x.getBoundingClientRect().bottom), 0);
}

export function scrollUnderPinned(el: HTMLElement | null) {
  if (el) window.scrollTo({ top: Math.max(0, window.scrollY + el.getBoundingClientRect().top - pinnedBottom()) });
}

/**
 * Open these folds (shelf ids, as `Shelf` and `openShelf` name them), then scroll to the first
 * element `selector` finds, just under what's pinned. It looks again a few times and follows the
 * page while it grows for a moment: Safari has no scroll anchoring, so covers still arriving above
 * can push the target off the screen (Nov 1, WebKit on an upright iPad).
 */
export function arriveAt(selector: string | (() => HTMLElement | null), open: string[] = []) {
  for (const id of open) openShelf(id);
  const find = typeof selector === 'string' ? () => document.querySelector<HTMLElement>(selector) : selector;
  const go = () => scrollUnderPinned(find());
  window.setTimeout(go, 30);
  window.setTimeout(go, 300);
  window.setTimeout(go, 900);
  if (typeof ResizeObserver !== 'undefined') {
    const ro = new ResizeObserver(() => go());
    ro.observe(document.body);
    window.setTimeout(() => ro.disconnect(), 2500);
  }
}
